export default __webpack_public_path__ + "static/media/PictCampMap.357db970.jpg";